import { useContext } from "react";
import { PageContext } from "context/Page";
import { racingFilters } from "@/features/racing/models/racingFilters";

const useTitleOverride = () => {
  const { title } = useContext(PageContext);

  const { data: titles } = racingFilters.shape.titles.safeParse([title]);

  return titles || [];
};

export { useTitleOverride };
